import { render, staticRenderFns } from "./MatchMakingLeaderboardList.vue?vue&type=template&id=5d537a19&scoped=true"
import script from "./MatchMakingLeaderboardList.vue?vue&type=script&lang=js"
export * from "./MatchMakingLeaderboardList.vue?vue&type=script&lang=js"
import style0 from "./MatchMakingLeaderboardList.vue?vue&type=style&index=0&id=5d537a19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d537a19",
  null
  
)

export default component.exports